import React, { useState, useMemo, useEffect } from 'react';
import { ResultsContent } from './components/ResultsContent/ResultsContent';
import { ResultsHeader } from './components/ResultsHeader/ResultsHeader';
import { ResultsSidebar } from './components/ResultsSidebar/ResultsSidebar';
import { Select } from '../../Components/Select/Select';

import { useLeaderboardEventsList } from '../../hooks/useLeaderboardEventsList';
import './Results.scss';
import { StatusBadge } from '../../Components/StatusBadge/StatusBadge';

export const Results: React.FC = () => {
  const { events } = useLeaderboardEventsList();

  const challengeOptions = useMemo(() => {
    return events.map((event) => ({
      value: event.id.toString(),
      label: event.name,
    }));
  }, [events]);

  const [selectedChallenge, setSelectedChallenge] = useState('');

  useEffect(() => {
    if (events.length > 0 && !selectedChallenge) {
      setSelectedChallenge(events[0].id.toString());
    }
  }, [events, selectedChallenge]);

  const selectedEventId = parseInt(selectedChallenge) || 1;

  const handleChallengeChange = (value: string) => {
    setSelectedChallenge(value);
  };

  const selectedEvent = events.find((e) => e.id.toString() === selectedChallenge) || events[0];

  return (
    <div className="results-page results-page__user">
      <div className="results-page-header">
        <h1>Results {selectedEvent && <StatusBadge isActive={selectedEvent.isActive} />}</h1>
        <div className="challenge-filter">
          <Select
            id="challenge-select"
            name="challenge"
            options={challengeOptions}
            value={selectedChallenge}
            onChange={handleChallengeChange}
            placeholder="Select Challenge"
          />
        </div>
      </div>
      <div className="results-main">
        <div className="results-left">
          <ResultsHeader selectedEventId={selectedEventId} />
          <ResultsContent selectedChallenge={selectedChallenge} />
        </div>
        <ResultsSidebar selectedEvent={selectedEvent} />
      </div>
    </div>
  );
};
